import { Payee } from '@root/api/ump-catalog-manager'

export enum TspType {
  GAMES = 'Пополнение игр',
  SERVICES = 'Сервисы',
  // PROGRAMS = 'Программы',
  TOP = 'Топ-сервисы',
  KEYS = 'Игровые ключи',
}

export enum TspFieldType {
  ComboBox = 'ComboBox',
  Vouchers = 'Vouchers',
  Banner1 = 'bannerweb1',
  Banner2 = 'bannerweb2',
}

export interface ServiceMetaType {
  title: string
  h1: string
  description: string
}

export type NewServiceType = string
export type DisabledServiceType = string
export type PercentFeeServiceType = string
export type PriorityListItemType = string

export interface CustomParamsType {
  isNew?: boolean
  isDisabled?: boolean
  isZeroFee?: boolean
  isWithPercentFee?: boolean
}

export interface PayeeWithCustomParamsType extends Payee {
  customParams?: CustomParamsType
}

export type TspListPagePayee = {
  providerName: string
  features?: {
    tsp_url?: string
    tsp_picture_web?: string
    vertical_cover?: string
  }
  customParams?: CustomParamsType
}

export type SearchPayee = {
  providerName: string
  icon?: string
  features?: {
    tsp_url?: string
    tsp_picture_web?: string
    platform_type?: string
  }
}

export type SteamAccountParam = {
  name: string
  hidden: boolean
}

export type SteamAccountPayee = {
  serviceId: string
  providerName: string
  subline?: string
  params?: SteamAccountParam[]
  features?: {
    tsp_url?: string
    tsp_picture_web?: string
    category_web?: string
  }
  customParams?: {
    isDisabled?: boolean
  }
}

export type SteamAccountVoucher = {
  serviceId: string
  features?: {
    country_web?: string
    buttonLabel?: string
  }
}

export type TspPagePayeeParam = {
  name: string
  hidden: boolean
  title?: string
  description?: string
  displayOrder?: number
  regExp?: string
}

export type TspPagePayee = {
  serviceId: string
  providerName: string
  icon?: string
  params?: TspPagePayeeParam[]
  features?: {
    tsp_url?: string
    tsp_picture_web?: string
    category_web?: string
    backgroundcategory?: string
    textAbovePayButton?: string
  }
  customParams?: {
    isDisabled?: boolean
    isWithPercentFee?: boolean
    isZeroFee?: boolean
  }
}

export type TspPageDenominationParam = {
  name: string
  defaultValue?: string
}

export type TspPageDenomination = {
  serviceId: string
  params?: TspPageDenominationParam[]
  features?: {
    country_web?: string
    buttonLabel?: string
    buttonIcon?: string
    iconsubcategory?: string
    colorsubcategory?: string
    subcategory?: string
  }
}

export type PaymentPayee = SteamAccountPayee | TspPagePayee
export type PaymentDenomination = SteamAccountVoucher | TspPageDenomination
